<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    :scrollable="$vuetify.breakpoint.smAndDown"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text v-bind="attrs" v-on="on">
        <span class="d-none d-sm-block">Registro</span>
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
    </template>

    <v-card v-if="!showConfirmation">
      <v-form ref="form" v-model="valid">
        <v-card-title>
          <span class="headline">Registro</span>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Cancelar</v-btn>
        </v-card-title>

        <v-card-text class="pt-3">
          <v-row>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="store.store_business_id"
                label="NIT / RUT  *"
                hide-details
                type="number"
                :rules="[(v) => !!v || 'ID es requerido']"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field
                v-model="store.store_name"
                label="Nombre de la Tienda *"
                required
                :rules="[(v) => !!v || 'Nombre es requerido']"
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field
                v-model="store.store_address"
                :rules="[(v) => !!v || 'La dirección es requerida']"
                label="Dirección "
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="store.store_city"
                :rules="[(v) => !!v || 'La ciudad es requerida']"
                label="Ciudad"
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="store.store_phone"
                label="Teléfono *"
                type="number"
                :rules="[(v) => !!v || 'Teléfono es requerido']"
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-select
                v-model="store.store_category"
                :rules="[(v) => !!v || 'El tipo de negocio es requerido']"
                :items="businessTypes"
                label="Tipo de negocio"
                outlined
                dense
                item-text="label"
                item-value="id"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.user_name"
                label="Nombre Completo *"
                required
                :rules="[(v) => !!v || 'Nombre es requerido']"
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.user_email"
                label="Email*"
                type="email"
                required
                outlined
                dense
                :rules="emailRules"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.user_password"
                label="Contraseña*"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                required
                :rules="passwordRules"
                hide-details
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="confirmPassword"
                label="Confirmar Contraseña*"
                :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showConfirmPassword ? 'text' : 'password'"
                @click:append="showConfirmPassword = !showConfirmPassword"
                required
                hide-details
                outlined
                dense
                :rules="[
                  (v) => !!v || 'Confirmación es requerida',
                  (v) => v === user.user_password || 'Las contraseñas no coinciden',
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="submitForm" :loading="loading">Registrar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <v-card v-if="showConfirmation">
      <v-card-title>Registro Procesado</v-card-title>
      <v-card-text>
        <p>Por favor, asegúrate de que la información proporcionada sea correcta.</p>
        <p><strong>Código de Tienda:</strong> {{ registeredStoreId }}</p>
        <p><strong>Nombre Registrado:</strong> {{ registeredUserName }}</p>
        <p>Una vez registrado, recibirás un correo electrónico de confirmación.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { webserver } from "../services/webserver.js";
export default {
  name: "StoreRegistrationDialog",
  data() {
    return {
      showConfirmation: false,
      registeredStoreId: "",
      registeredUserName: "",
      dataResponse: null,
      dialog: false,
      valid: false,
      currentStep: 1,
      loading: false,
      dateMenu: false,
      showPassword: false,
      showConfirmPassword: false,
      confirmPassword: "",
      userPhotoFile: null,
      storeLogoFile: null,

      // Datos de la tienda
      store: {
        store_id: "", // Se generará automáticamente
        store_name: "",
        store_category: "",
        store_address: "",
        store_city: "",
        store_phone: "",
        store_email: "",
        store_url: "",
        store_prefix: "",
        store_type: "",
        store_owner: "",
        PartyIdentification_Id: "",
        PartyName: "",
        TaxLevelCode: "",
        store_business_id: "",
        store_CentroCosto: "",
        store_Caja: "",
        store_target: 0,
        dueDate: null,
        status: "Active",
        store_logo: null,
        store_header: null,
        store_footer: null,
        store_days: "",
        store_invoice: 0,
      },
      // Datos del usuario
      user: {
        user_email: "",
        user_password: "",
        user_name: "",
        user_photo: null,
        user_access: "owner", // Por defecto será "owner" y no puede cambiarse
        token: null,
        token_active: null,
        publickey: null,
        user_code: "",
      },
      // Opciones para los selects
      storeTypeItems: [
        { text: "Físico", value: "F" },
        { text: "Virtual", value: "V" },
        { text: "Híbrido", value: "H" },
      ],
      taxLevelItems: [
        { text: "Régimen Común", value: "1" },
        { text: "Régimen Simplificado", value: "2" },
        { text: "Gran Contribuyente", value: "3" },
      ],

      businessTypes: [
        { id: "ropa_accesorios", label: "Tienda de ropa y accesorios" },
        { id: "Electrónica", label: "Electrónica y tecnología" },
        { id: "Supermercado", label: "Supermercado o minimercado" },
        { id: "Restaurante", label: "Restaurante" },
        { id: "Cafetería", label: "Cafetería o panadería" },
        { id: "Belleza", label: "Salón de belleza/Barbería" },
        { id: "Farmacia", label: "Farmacia" },
        { id: "Florería", label: "Florería o tienda de regalos" },
        { id: "Tienda en línea", label: "Tienda en línea (e-commerce)" },
        { id: "Entretenimiento", label: "Cine, bar o centro de entretenimiento" },
        { id: "Taller", label: "Taller mecánico o de reparaciones" },
        { id: "Gimnasio", label: "Gimnasio o estudio deportivo" },
        { id: "Otro", label: "Otro tipo de negocio" },
      ],

      // Reglas de validación
      emailRules: [
        (v) => !!v || "El email es requerido",
        (v) => /.+@.+\..+/.test(v) || "El email debe ser válido",
      ],
      passwordRules: [
        (v) => !!v || "La contraseña es requerida",
        (v) => v.length >= 6 || "La contraseña debe tener al menos 6 caracteres",
      ],
    };
  },
  computed: {
    formattedDate() {
      if (!this.store.dueDate) return "";
      return new Date(this.store.dueDate).toLocaleDateString();
    },
  },
  methods: {
    generateStoreId() {
      // 1. Obtener los últimos 3 dígitos del timestamp (para unicidad)
      const timestampPart = String(new Date().getTime()).slice(-3); // Ej: "456"

      // 2. Generar 3 dígitos aleatorios (para evitar colisiones en el mismo ms)
      const randomPart = String(Math.floor(Math.random() * 900) + 100); // Rango: 100-999

      // 3. Combinar y asegurar 6 dígitos
      const uniqueId = timestampPart + randomPart; // Ej: "456789" -> 6 dígitos
      return uniqueId.substring(0, 6); // Garantiza longitud (innecesario si se usan 3+3)
    },

    async submitForm() {
      if (!this.$refs.form.validate()) return;

      //this.loading = true;

      try {
        var md5 = require("md5");
        const passwordHash = md5(this.user.user_password);
        this.user.user_password = passwordHash; // Guardar hash en lugar de la contraseña
        // Generar ID de tienda si no existe
        if (!this.store.store_id) {
          this.store.store_id = this.generateStoreId();
        }

        // Asignar el store_id al usuario
        this.user.store_id = this.store.store_id;
        const Register = {
          store: "202501",
          company: this.store,
          user: this.user,
        };
        // Simulamos la respuesta exitosa
        webserver("Register", Register, (response) => {
          if (response.success) {
            // Store response data for confirmation card
            this.registeredStoreId = response.data.user.store_id;
            this.registeredUserName = response.data.user.user_name;

            this.showConfirmation = true;
          }
          console.log("Login successful:", response);
        });
      } catch (error) {
        this.loading = false;
        console.error("Error al registrar:", error);
        // Mostrar mensaje de error
        //this.$emit("registration-error", error);
      }
    },

    showSuccessMessage() {
      // Emitir evento para mostrar notificación
      this.$emit("registration-success", {
        store: this.store,
        user: this.user,
      });
    },

    closeDialog() {
      this.dialog = false;
      // Resetear el formulario al cerrar
      this.$nextTick(() => {
        this.$refs.form.reset();
        this.currentStep = 1;
      });
    },
  },
};
</script>

<style scoped>
.v-stepper {
  box-shadow: none !important;
}
</style>
